import { getApiErrorMessage } from '../api/client';
import { placesApi } from '../api/modules/places.api';

/**
 * Places search via utkarsh-backend (/places/*).
 * No Google Maps JS script and no browser API key.
 */

export function createPlacesSessionToken() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `sess_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

export async function autocompletePlaces(input, { sessionToken } = {}) {
  const q = String(input || '').trim();
  if (!q || q.length < 2) return [];

  try {
    const items = await placesApi.autocomplete({
      q,
      ...(sessionToken ? { sessionToken } : {}),
    });
    return Array.isArray(items) ? items : [];
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Places search failed'));
  }
}

export async function getPlaceDetails(placeId, { sessionToken } = {}) {
  if (!placeId) throw new Error('Invalid place');
  try {
    const place = await placesApi.details({
      placeId,
      ...(sessionToken ? { sessionToken } : {}),
    });
    if (!place) throw new Error('Place details failed');
    return place;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Place details failed'));
  }
}
